module.exports = "/_next/static/images/a6e654e1c8776efbe8d26d266eacb206-requirements-xs.jpg";